import { api_url } from "../../../utils";

const MotorizacionAutos = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=motorizacion&schema_city=",
    zindex: 1,
    type: "graduated",
    popup: {
        default: {
            content: {
                es: {
                    nombre: "Nombre de la macrozona: ",
                    num_autos: "Número de autos: ",
                    num_motos: "Número de motos: ",
                    auto_1000h: "Tasa de motorización auto (veh./1000 hab.): ",
                    motos_1000:
                        "Tasa de motorización moto (motos /1000 hab.): ",
                },
            },
            separators: {
                decimal: [],
                thousand: ["num_autos", "num_motos"],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.MotorizacionAutos",
    style: {
        regular: false,
        fillColor: "rgba(0, 0, 0)",
        strokeColor: "rgb(35, 35, 35)",
        strokeWidth: 0,
        strokeLineDash: [],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.MotorizacionAutos.title",
            subtitle: "",
            attribute: "auto_1000h",
            symbol: "rectangle",
            legendCustomCssClass: "",
            class: [
                {
                    fillColor: "rgb(253, 243, 237)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    min: 0,
                    max: 49,
                    label: "Mobility Indicators Content.layersLegend.MotorizacionAutos.classes.1",
                },
                {
                    fillColor: "rgb(251, 227, 214)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    min: 50,
                    max: 74,
                    label: "Mobility Indicators Content.layersLegend.MotorizacionAutos.classes.2",
                },
                {
                    fillColor: "rgb(242, 170, 132)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    min: 75,
                    max: 99,
                    label: "Mobility Indicators Content.layersLegend.MotorizacionAutos.classes.3",
                },
                {
                    fillColor: "rgb(192, 79, 21)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    min: 100,
                    max: 200,
                    label: "Mobility Indicators Content.layersLegend.MotorizacionAutos.classes.4",
                },
            ],
        },
    },
};

export default MotorizacionAutos;
